<div class="content">
  <p-table
    #table
    [stateKey]="storageKey ? 'data-table-state-' + storageKey : ''"
    [stateStorage]="stateStorage"
    [value]="tableData.values"
    [loading]="loading"
    [paginator]="!infiniteScroll"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [sortOrder]="-1"
    sortMode="multiple"
    [resizableColumns]="true"
    [lazy]="lazy"
    (onLazyLoad)="loadNextPage($any($event))"
    [rowsPerPageOptions]="rowsPerPageOptions"
    currentPageReportTemplate="{currentPage} sur {totalPages} page(s) - {totalRecords} éléments"
    [showCurrentPageReport]="true"
    styleClass="p-datatable-sm p-datatable-striped"
    [dataKey]="dataKey"
    [scrollable]="infiniteScroll"
    [scrollHeight]="infiniteScroll ? scrollHeight : ''"
    [globalFilterFields]="globalFilterFields"
    [reorderableColumns]="true"
    [columns]="data.headers"
    (onEditComplete)="onCellEditComplete($event)"
    (onEditInit)="onCellEditInit($event)"
  >
    <ng-template pTemplate="caption">
      <div class="flex">
        @if (filtering) {
          <div
            class="text-sm cursor-pointer text-sm text-gray-500 relative mr-2"
            style="top: 10px"
            title="Afficher / Masquer les filtres"
            (click)="toggleFiltering()"
          >
            @if (!toggleFilter) {
              <i class="pi pi-filter"></i>
            } @else {
              <i class="pi pi-filter-fill"></i>
            }
          </div>
        }
        @if (cellEditing) {
          <div
            class="text-sm cursor-pointer text-sm text-gray-500 absolute mr-2"
            style="top: 42px"
            title="Editer en ligne directement"
            (click)="toggleCellEditing()"
          >
            @if (toggleCellEdit) {
              <i class="pi pi-lock-open"></i>
            } @else {
              <i class="pi pi-lock"></i>
            }
          </div>
        }
        <div class="p-input-icon-left p-input-icon-right" style="height: 34px">
          <i class="pi pi-search cursor-pointer"></i>
          <input
            pInputText
            type="text"
            placeholder="Rechercher..."
            class="p-inputtext p-component"
            [(ngModel)]="inputValue"
            (input)="table.filterGlobal($any($event.target).value, 'contains')"
          />
          <i class="pi pi-times cursor-pointer" (click)="inputValue = ''; table.filterGlobal('', 'contains')"></i>
        </div>
        @if (showExpandAll) {
          <p-button
            icon="pi pi-arrows-h"
            class="ml-2 mr-2"
            (click)="expandAll()"
            label=""
            title="Réinitialiser la largeur des colonnes"
          ></p-button>
        }
        <ng-content></ng-content>
      </div>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th pResizableColumn>Actions</th>
        @for (header of columns; track header.field) {
          @if (header.sort) {
            <th pReorderableColumn pResizableColumn [pSortableColumn]="getSortField(header)">
              {{ header.header }}
              @if (header.sort) {
                <p-sortIcon [field]="getSortField(header)"></p-sortIcon>
              }
              <!-- todo why "p-sortable-column-badge" is no shown? -->
            </th>
          }
          @if (!header.sort) {
            <th pReorderableColumn pResizableColumn>
              {{ header.header }}
            </th>
          }
        }
      </tr>
      @if (filtering && toggleFilter) {
        <tr>
          <th></th>
          @for (header of columns; track header.field) {
            @if (["multi", "in"].includes(header.type)) {
              <th>
                <p-columnFilter [field]="header.field" [matchMode]="header.type" [showMenu]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect
                      [ngModel]="value"
                      [options]="mapFilteringOptions[header.field]"
                      placeholder="Tous"
                      appendTo="body"
                      (onChange)="filter($any($event).value)"
                      optionValue="refId"
                      optionLabel="name"
                    >
                      <ng-template let-option pTemplate="item">
                        <div class="p-multiselect-representative-option">
                          {{ option.name }}
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </th>
            }
            @if (!["multi", "in"].includes(header.type)) {
              <th [class]="header.type">
                <p-columnFilter [type]="header.type || 'text'" [field]="header.field"></p-columnFilter>
              </th>
            }
          }
          <th></th>
        </tr>
      }
    </ng-template>

    <ng-template pTemplate="body" let-item let-ri="rowIndex" let-expanded="expanded" let-columns="columns">
      <tr [ngClass]="{ selected: item.id == selectedRow, 'row-colorizing': colorizingRow(item) }">
        <td class="actions">
          @for (action of tableData.actions; track action.id) {
            @if (action.isVisible ? action.isVisible(item) : true) {
              <p-button
                [title]="action.label || ''"
                type="button"
                [icon]="action.icon + ' pi'"
                (click)="onActionClick(action.id, item, ri)"
                styleClass="p-button-text"
              ></p-button>
            }
          }
        </td>

        @for (header of columns; track header.field) {
          <td
            [title]="item[header.field]"
            [style]="getStyle(header, item[header.field], item[header.field + '_color'])"
            [pEditableColumn]="item"
            [pEditableColumnField]="header.field"
          >
            @if (cellEditing && toggleCellEdit) {
              <p-cellEditor>
                <ng-template pTemplate="input">
                  @if (header.readonly) {
                    {{ item[header.field] }}
                  } @else if (header.time) {
                    <p-calendar
                      [(ngModel)]="item[header.field]"
                      appendTo="body"
                      dateFormat="dd/mm/yy"
                      [showTime]="false"
                      [showIcon]="true"
                      [firstDayOfWeek]="1"
                      [timeOnly]="header.timeOnly"
                    >
                    </p-calendar>
                  } @else {
                    @if (header.ref) {
                      <app-dropdown-firestore
                        [referentialKey]="header.ref"
                        [(ngModel)]="item[header.field.replace('_label', '')]"
                        [autoFetchData]="true"
                      ></app-dropdown-firestore>
                    } @else {
                      <input pInputText type="text" [(ngModel)]="item[header.field]" />
                    }
                  }
                </ng-template>
                <ng-template pTemplate="output">
                  {{
                    header.pipeDate && item[header.field]
                      ? (item[header.field] | date: header.pipeDate)?.replace(":", "h")
                      : item[header.field]
                  }}
                </ng-template>
              </p-cellEditor>
            } @else {
              {{
                header.pipeDate && item[header.field]
                  ? (item[header.field] | date: header.pipeDate)?.replace(":", "h")
                  : item[header.field]
              }}
            }
          </td>
        }
      </tr>
      @if (infiniteScroll && ri === tableData.values.length - 1) {
        <div (appDeferLoad)="showMore()" style="width: 100%; height: 1px">&nbsp;</div>
      }
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-item>
      <ng-container *ngTemplateOutlet="expansionRowTemplate; context: { $implicit: item }"></ng-container>
    </ng-template>
  </p-table>
</div>
